import {Component, OnDestroy, OnInit} from "@angular/core";
import RegroupementPlatDTO from "../../core/dtos/conditionnement/regroupement-plat-d-t-o";
import {Auth2Service} from "../../core/services/security/auth2.service";
import {Router} from "@angular/router";
import {Subscription} from "rxjs";
import {RegroupementPlatService} from "../../core/services/conditionnements/regroupement/regroupement-plat.service";
import {
  RegroupementPlatFilterMl
} from "../../core/models/gestion-conditionnements/regroupement/plat/regroupement-plat-filter-ml";
import {confirm} from "devextreme/ui/dialog";
import {ToastService} from "../../core/services/technique/toast.service";
import {MSG_KEY, MSG_SEVERITY} from "../../core/constants";
import {ButtonThemeEnum} from "../../shared/ui/button/button-theme-enum";

@Component({
    selector: 'yo-regroupement-plat',
    templateUrl: './regroupement-plat.component.html',
    styleUrls: ['./regroupement-plat.component.scss'],
    standalone: false
})

export class RegroupementPlatComponent implements OnInit, OnDestroy {
  regroupements: RegroupementPlatDTO[];
  selectedRows: number[] = [];
  subRegroupementPlatList: Subscription;


  constructor(public auth2Svc: Auth2Service,
              private router: Router,
              private regroupementSvc: RegroupementPlatService,
              private toastSvc: ToastService) {
  }

  ngOnInit() {
    const filter = new RegroupementPlatFilterMl();
    this.subRegroupementPlatList = this.regroupementSvc.getRegroupementPlatByFilter(filter).subscribe((res) => {
      if (res)
      this.regroupements = res.resultList
    })
  }

  ngOnDestroy() {
  }

  async deleteValues() {
    const result = confirm(`Êtes vous sûr de vouloir supprimer les regroupements de plat sélectionnés  ?`, 'Suppression des regroupements de plat');
    const isDeleted: boolean = await result;
    if (isDeleted) {
      this.regroupementSvc.delete(this.selectedRows).subscribe({
        next: () => {
          this.regroupements = this.regroupements.filter(regroupementPlat => !this.selectedRows.includes(regroupementPlat.id));
          this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.SUCCESS, `Suppression des regroupements de plat sélectionnés réalisée avec succès`);
        }
      });
    }
  }

  isActionDisabled(idSite: number): boolean {
    return this.auth2Svc.isSiteLocal(idSite);
  }

  createRougrepemntPlat() {
    this.router.navigate(['/gestion-conditionnements/regroupement-plat-plc/settings'])
  }

  editRegroupement(id) {
    this.router.navigate([`/gestion-conditionnements/regroupement-plat-plc/settings/${id}`])
  }

  public readonly ButtonThemeEnum = ButtonThemeEnum;
}
